<template>
  <Main :requestUserData="false"></Main>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { TokenService } from "@/api/storage.js";
import { LoadingRequest } from "@/mixins/LoadingMixin";

export default {
  name: "NewQuotationAgroGuest",
  mixins: [LoadingRequest],
  computed: {
    ...mapState("me", ["myInfo"]),
    groupId() {
      return this.$route.params.groupId;
    },
    officeId() {
      return this.$route.params.officeId;
    }
  },
  created() {
    if (TokenService.getToken()) {
      this.$router.push({ name: "add quotation", query: { group_id: this.groupId } });
    } else {
      this.withLoading(
        this.guestLogin({
          group_id: this.groupId,
          office_id: this.officeId
        })
      )
        .then(() => {
          this.setGuestUserInfo("agronegocio");
          this.$router.push({ name: "add quotation" });
        })
        .catch(() => {
          this.$router.push({ name: "login" });
        });
    }
  },
  methods: {
    ...mapActions("auth", ["guestLogin"]),
    ...mapActions("me", ["setGuestUserInfo"])
  }
};
</script>
